module.exports = __webpack_public_path__ + "static/img/42.562721b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/42.jpg
// module id = zs3v
// module chunks = 1